import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useSelectColumn,
  useDatePickerColumn,
  BaseButtonMore,
  useCreateModal,
  BaseButton,
  XrkMessage
} from 'xrk-components';
import { formatter } from '@/utils';
import {
  queryInvoiceList,
  listSupplier,
  listAsp,
  invoiceType,
  invoiceExport,
  download2Center,
  jlBatchDownload
} from '@V/invoice/src/data-source/apis';
import { useRouteMeta } from '@hooks/common';
import { ORDER_TYPE } from '@constants/order';
import { taxPatternMapping } from '@constants/project';
import { INVOICE_STATUS, INVOICE_TYPE } from '@V/invoice/src/constants';
import InvoiceDetailDialog from '@V/invoice/src/components/invoice-detail-dialog';
import InvoiceDetailGtListDialog from '@V/invoice/src/components/invoice-detail-gt-dialog';
import { invoiceStatusCol } from '@V/invoice/src/fields/columns';
import { InvoiceWtdkPListDialog } from './invoice-wtdk';
import InvoicePriceTaxDialog from './invoice-price-tax-dialog.vue';
import { useBatchDownload } from '@V/invoice/src/hooks';
import { IS_PLATFORM_TYPE_1 } from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-record-list',
  setup(__props) {

const routeMeta = useRouteMeta();
const isSupplier = [3].includes(+routeMeta.functionCode);
const isAsp = [2].includes(+routeMeta.functionCode);

const xrkTableRef = ref();
const { selectionField, download } = useBatchDownload({
  xrkTableRef,
  ajax: jlBatchDownload
});

const getListAjax = async params => {
  return queryInvoiceList(params);
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [
    isSupplier &&
      useSelectColumn({
        prop: 'aspId',
        label: '购买方',
        config: {
          clearable: true,
          filterUseRemote: true,
          remoteMethod: async name => {
            const res: any = await listAsp({
              name
            });
            return res;
          },
          maxlength: 50
        }
      }),
    [1, 2].includes(+routeMeta.functionCode) &&
      useSelectColumn({
        prop: '_fId', // 自定义组合字段
        label: '销售方',
        config: {
          clearable: true,
          filterUseRemote: true,
          remoteMethod: async name => {
            const res: any = await listSupplier({
              name
            });
            return res;
          },
          maxlength: 50,
          valueKey: '_fId',
          labelKey: 'name'
        }
      }),
    useSelectColumn({
      prop: 'orderMixtureType',
      label: '订单类型',
      config: {
        clearable: true,
        filterUseRemote: true,
        remoteMethod: async () => {
          return invoiceType();
        },
        maxlength: 50
      }
    }),
    IS_PLATFORM_TYPE_1 &&
      useSelectColumn({
        prop: 'professionType',
        label: '交易结构',
        config: {
          placeholder: '请选择',
          options: taxPatternMapping
        }
      }),
    useDatePickerColumn({
      prop: 'time1',
      label: '申请日期',
      style: { width: '220px' },
      config: {
        type: 'daterange',
        startPlaceholder: '时间始',
        endPlaceholder: '时间止',
        clearable: true
      },
      listener: {
        onChange: (value, searchObj) => {
          if (!value) {
            searchObj.createAtStart = '';
            searchObj.createAtEnd = '';
          } else {
            searchObj.createAtStart = value[0];
            searchObj.createAtEnd = value[1];
          }
        }
      }
    }),
    useDatePickerColumn({
      prop: 'time2',
      label: '更新时间',
      style: { width: '220px' },
      config: {
        type: 'daterange',
        startPlaceholder: '时间始',
        endPlaceholder: '时间止',
        clearable: true
      },
      listener: {
        onChange: (value, searchObj) => {
          if (!value) {
            searchObj.authAtStart = '';
            searchObj.authAtEnd = '';
          } else {
            searchObj.authAtStart = value[0];
            searchObj.authAtEnd = value[1];
          }
        }
      }
    }),
    useSelectColumn({
      prop: 'invoiceStatus',
      label: '开票状态',
      config: {
        placeholder: '请选择',
        options: INVOICE_STATUS
      }
    })
  ].filter(Boolean),
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  otherComponents: [
    {
      render() {
        return (
          <>
            <BaseButton
              type="primary2"
              click={async () => {
                await download();
              }}
            >
              批量导出
            </BaseButton>
          </>
        );
      }
    }
  ]
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    selectionField(),
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px',
      fixed: 'left'
    }),
    useTableColumn({
      label: '发票申请编号',
      prop: 'invoiceOrderNo',
      width: '180px'
    }),
    useTableColumn({
      label: '购买方',
      prop: 'enterpriseName',
      width: 300
    }),
    useTableColumn({
      label: '销售方',
      prop: 'supplierName',
      width: 300
    }),
    useTableColumn({
      label: '订单类型',
      prop: 'orderMixtureType',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(cellValue, () => ORDER_TYPE[cellValue].label)
    }),
    IS_PLATFORM_TYPE_1 &&
      useTableColumn({
        label: '交易结构',
        prop: 'professionType',
        formatter: ({ cellValue }) =>
          formatter.defaultFormat(
            cellValue,
            () => taxPatternMapping[cellValue].label
          )
      }),
    useTableColumn({
      label: '申请时间',
      prop: 'createAt',
      formatter: ({ cellValue }) => formatter.date(cellValue),
      width: '180px'
    }),
    useTableColumn({
      label: '价税合计(元)',
      prop: 'invoiceAmount',
      render({ row }) {
        return (
          <BaseButton
            type="text"
            click={() => {
              useCreateModal(InvoicePriceTaxDialog, {
                invoiceApplyId: row.id,
                invoiceBusinessType: row.invoiceBusinessType
              });
            }}
          >
            {formatter.fen2yuan(row.invoiceAmount)}
          </BaseButton>
        );
      }
    }),
    useTableColumn({
      label: '开票类目',
      prop: 'itemName'
    }),
    useTableColumn({
      label: '票面金额(元)',
      prop: 'sumAmount',
      formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
    }),
    useTableColumn({
      label: '发票类型',
      prop: 'invoiceType',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(cellValue, () => INVOICE_TYPE[cellValue].label)
    }),
    invoiceStatusCol,
    useTableColumn({
      label: '更新时间',
      prop: 'authAt',
      formatter: ({ cellValue }) => formatter.date(cellValue),
      width: '180px'
    }),

    useTableColumn({
      label: '操作',
      prop: 'handlerCol',
      fixed: 'right',
      width: '240px',
      render: ({ row }) => {
        const isAspOpen = [1, 4, 5, 7, 8].includes(row.invoiceBusinessType); // 服务商发起
        const isSupplierOpen = [6].includes(row.invoiceBusinessType); // 供应商发起
        const btns = [
          {
            content: '详情',
            click: () => {
              // 委托代开
              if (row.invoiceBusinessType === 2) {
                useCreateModal(InvoiceWtdkPListDialog, {
                  id: row.id
                });
                return;
              }
              // 园区个体
              if (row.invoiceBusinessType === 3) {
                useCreateModal(InvoiceDetailGtListDialog, {
                  id: row.id
                });
                return;
              }
              // 其他
              useCreateModal(InvoiceDetailDialog, {
                id: row.id,
                detailType:
                  (isSupplier &&
                    [1, 5].includes(row.invoiceStatus) &&
                    isSupplierOpen) ||
                  (isAsp && [1, 5].includes(row.invoiceStatus) && isAspOpen)
                    ? 10 // 供应商对应的类型与服务商对应的类型，蓝红待审核状态，可审核
                    : 1, // 查看
                onSuccess() {
                  xrkTableRef.value.initCurrentList();
                }
              });
            }
          },
          // 供应商上传蓝票，待开票||已驳回
          isSupplier &&
            [0, 3].includes(row.invoiceStatus) &&
            isAspOpen && {
              content: '上传发票',
              click: () => {
                useCreateModal(InvoiceDetailDialog, {
                  id: row.id,
                  detailType: 2,
                  onSuccess() {
                    xrkTableRef.value.initCurrentList();
                  }
                });
              }
            },
          // 供应商上传红冲，待红冲||已驳回红冲
          isSupplier &&
            [4, 7].includes(row.invoiceStatus) &&
            isAspOpen && {
              content: '红冲开票',
              click: () => {
                useCreateModal(InvoiceDetailDialog, {
                  id: row.id,
                  detailType: 3,
                  onSuccess() {
                    xrkTableRef.value.initCurrentList();
                  }
                });
              }
            },
          // 购买方发起红冲申请：蓝票已过&&订单类型
          ((isAsp && row.invoiceStatus === 2 && isAspOpen) ||
            (isSupplier && row.invoiceStatus === 2 && isSupplierOpen)) && {
            content: '红冲',
            click: () => {
              useCreateModal(InvoiceDetailDialog, {
                id: row.id,
                detailType: 7,
                onSuccess() {
                  xrkTableRef.value.initCurrentList();
                }
              });
            }
          },
          {
            content: '下载开票信息',
            click: async () => {
              if (row.invoiceBusinessType === 3) {
                await download2Center({ invoiceApplyId: row.id });
                XrkMessage.success('操作成功，请前往下载中心进行下载查看');
              } else {
                await invoiceExport({ invoiceId: row.id });
              }
            }
          },
          // 补充1
          isSupplier &&
            row.isSupplement1 === 1 &&
            [2, 6].includes(row.invoiceStatus) &&
            isAspOpen && {
              content: '补充材料1',
              click: () => {
                useCreateModal(InvoiceDetailDialog, {
                  id: row.id,
                  detailType: 4,
                  onSuccess() {
                    xrkTableRef.value.initCurrentList();
                  }
                });
              }
            },
          // 补充2
          isSupplier &&
            row.isSupplement2 === 1 &&
            [2, 6].includes(row.invoiceStatus) &&
            isAspOpen && {
              content: '补充材料2',
              click: () => {
                useCreateModal(InvoiceDetailDialog, {
                  id: row.id,
                  detailType: 5,
                  onSuccess() {
                    xrkTableRef.value.initCurrentList();
                  }
                });
              }
            }
        ].filter(item => item);

        return (
          <BaseButtonMore
            key={Date.now()}
            maxCount={2}
            style={{ 'justify-content': 'right' }}
            btns={btns}
          ></BaseButtonMore>
        );
      }
    })
  ].filter(Boolean)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(XrkTable), {
    ref_key: "xrkTableRef",
    ref: xrkTableRef,
    getListAjax: getListAjax,
    searchConfig: searchConfig.value,
    tableConfig: tableConfig.value
  }, null, 8, ["searchConfig", "tableConfig"]))
}
}

})